import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    question: 'Como funciona a instalação?',
    answer: 'A instalação é totalmente gratuita e realizada por técnicos especializados. Agendamos um horário que melhor se encaixe na sua rotina e o processo leva em média 1 a 2 horas.',
  },
  {
    question: 'Tem fidelidade?',
    answer: 'Sim, trabalhamos com fidelidade. Ela garante condições especiais e benefícios exclusivos durante o período contratado. Consulte nossa equipe para entender os prazos e vantagens disponíveis.',
  },
  {
    question: 'O roteador Wi-Fi está incluso?',
    answer: 'Sim! Todos os planos incluem um roteador Wi-Fi de alta performance. Planos a partir de 250MB incluem roteador Wi-Fi 6.',
  },
  {
    question: 'Qual a diferença entre fibra óptica e internet via rádio?',
    answer: 'A fibra óptica transmite dados pela luz, garantindo maior velocidade, estabilidade e menor latência. Diferente do rádio, a fibra não sofre com interferências climáticas.',
  },
  {
    question: 'Vocês atendem minha região?',
    answer: 'Estamos em constante expansão! Utilize nossa ferramenta de consulta de cobertura ou entre em contato pelo WhatsApp para verificar a disponibilidade no seu endereço.',
  },
  {
    question: 'Como funciona o suporte técnico?',
    answer: 'Nosso suporte técnico está disponível para te ajudar sempre que precisar. Você pode entrar em contato pelos nossos canais de atendimento, e nossa equipe irá analisar sua solicitação e oferecer a melhor solução de forma rápida e eficiente. Trabalhamos para garantir o menor tempo de resposta possível e manter seus serviços funcionando sem interrupções.',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="relative py-24 lg:py-32">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="font-inter text-xs font-semibold text-secondary uppercase tracking-widest">
            Dúvidas Frequentes
          </span>
          <h2 className="font-poppins font-bold text-3xl lg:text-5xl mt-4 tracking-tight">
            Perguntas <span className="gradient-text">comuns</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="glass-card rounded-xl border-0 px-6 overflow-hidden"
              >
                <AccordionTrigger className="font-poppins font-semibold text-base text-foreground py-5 hover:no-underline transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-inter text-sm text-muted-foreground pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}